import { GIT_VERSION } from './version';

// export const app_version = GIT_VERSION;

const features_config = {
    enable_demo_reset_button: false
}

export const function_config = {
    ...features_config,
}

export default function_config;